import React,{useState} from 'react'
import LoanUtilityMain from './newloanutility'
import ProcessingFee from './ProcessingFee'
import UploadBulkProduct from './uploadBulkProduct'
export default function configMain() {
const [tabs,setabs]=useState('loan')
    const handletabs =(type)=>{
        setabs(type)
    }
  return (
    <>
    <div className="LoanUtility">
        
        <div className="tabs">
            <div className={`tab ${tabs === 'loan' ? 'active' : ''}`} onClick={()=>handletabs('loan')}>
                <h5>Loan Utility</h5>
            </div>
            <div className={`tab ${tabs === 'processing' ? 'active' : ''}`} onClick={()=>handletabs('processing')}>
                <h5>Processing Fee</h5>
            </div>
            <div className={`tab ${tabs === 'uploadBulkProduct' ? 'active' : ''}`} onClick={()=>handletabs('uploadBulkProduct')}>
                <h5>Upload Bulk Product</h5>
            </div>
        </div>

        {
            tabs === 'loan' ?
            <LoanUtilityMain />
        :''}
        {
            tabs === 'processing' ?
            <ProcessingFee />
        :''}
        {
            tabs === 'uploadBulkProduct' ?
            <UploadBulkProduct />
        :''}
    </div>
    </>
  )
}
